import store from '../../store';

export default {
    "title": "Shipment",
    "entityName": "shipment",
    "noLabelUpsertBtn":false,
    "noLabelRemoveBtn":true,
    "pagination": {
        "rowsPerPage": 10,
        "page": 1,
        "sortBy": "id",
        "descending": true
    },
    filterStorage: {},
    "fields": [

        {
            full:true,
            "value": "protocol_id",
            "text": "Protocol",
            "title": "name",
            "type": "autocomplete",
            "table": {
                "sortable": true,
                "filter": true
            },
            render:  item => item.protocol.name
        },
        {
            full:true,
            "value": "owner.surname",
            "text": "Insert By",
            "title": "owner.surname",
            "type": "text",
            "table": {
                "sortable": true,
                "filter": true
            },
            render:  item => item.owner.surname,
            tooltip: (item) => { return item.insert_at }
        },
        {
            full:true,
            "value": "pickup_date",
            "text": "Pickup Date",
            "type": "component",
            "name":"app-daterange",
            "bind" : {
                displayFormat:'MM-dd',
                clearable: true,
            },
            "table": {
                "sortable": true,
                "filter": true
            },
            // on: (item) => {
            //     console.log('on', item)
            // },
            filter: (filters, filter) => {
                if(!filter.start)
                    return
                return {'pickup_date': `>=${filter.start}`, 'shipment.pickup_date': `<=${filter.end}`}
            },
            render:  item => { 
                return item.pickup_date + (item.pickup_hour ? "<br> ( " + item.pickup_hour.start + ' - ' + item.pickup_hour.end +' )' : '')
            },
        },
        {
            full:true,
            "value": "pickup_id",
            "text": "Pickup point",
            "title": "name",
            "type": "autocomplete",
            "table": {
                "sortable": true,
                "filter": true
            },
            render:  item => { 
                return (item.pickup?.site_id ? 'Site ' : 'Lab ') + item.pickup?.city
            },
            tooltip: item => {
                return item.pickup?.name
            }
        },
        {
            full:true,
            "value": "delivery_id",
            "text": "Delivery point",
            "title": "name",
            "type": "autocomplete",
            "table": {
                "sortable": true,
                "filter": true
            },
            // render: item => `${item.site.factor_label}`,
            render:  item => {
                return (item.delivery?.site_id ? 'Site ' : 'Lab ') + item.delivery?.city
            },
            tooltip: item => {
                return item.delivery?.name
            }
        },
    


        {
            small:true,
            "value": "carrier",
            "text": "Carrier",
            // "type": "list",
            // list: ['EMN Logistic', 'DHL', 'FEDEX', 'SPECIAL SERVICES', 'TNT', 'UPS'],
            "readonly":true,
            "table": {
                "sortable": true,
                "filter": true
            },
            filter: (item, search) => [{ 'carrier': `%${search}%`},{'num':`${search}`},{'tracking_number':`${search}`}],
            click: item => {
                var value = null
                if(item.carrier == 'EMN Logistic' || item.carrier == 'SPECIAL SERVICES') {
                    if(item.num) {
                        value = item.num
                    }
                } else {
                    if(item.tracking_number) {
                        value = item.tracking_number
                    }
                }

                if(value) {
                    navigator.clipboard.writeText(value);
                }
            },
            render:  item => {
                if(!item.carrier) {
                    return ''
                }

                var str = item.carrier;

                if(item.carrier == 'EMN Logistic' || item.carrier == 'SPECIAL SERVICES') {

                    if(item.num) {
                        str +=  ' (' + item.num + ')'
                    }
                } else {
                    if(item.tracking_number) {
                        str +=  ' (' + item.tracking_number + ')'
                    }
                }
                return str
            },
            "validators": [
                "required"
            ]
        },

     
        {
            small:true,
            "value": "status",
            "text": "Status",
            "type": "list",
            list:["Draft", "Created", "Confirmed", "Shipped", "Delivered", "Received", "Canceled"],
            "table": {
                "sortable": true,
                "filter": true
            },
            "validators": [
                "required"
            ]
        },


    ],
    "actions": [
        { "value": "update", "text": "Edit", "icon": "mdi-pencil", "color": "primary" },
        { "value": "remove", "text": "Delete", "icon": "mdi-delete", "color": "primary", 
            disable:(item) => { 
                return item.num || (store.getters.role != 'Administrator' && store.getters.role != 'EMN Logistic') || (item.status != 'Draft' && item.status != 'Created')
            }
        },
        "audit_trail"
    ]
}